module.exports = __webpack_public_path__ + "img/1.35e72b43.png";